@if(userProfleLoading$ | async)
{
<app-loading-spinner></app-loading-spinner>
}
@else if((profileMe$ | async) === null){
<div>{{"ml_151222" | translate}}</div>
}
@else if((profileMe$ | async).apexId === null){
<div>{{"ml_151221" | translate}}</div>
}
@else {

<mat-toolbar color="primary">
  <button type="button" class="me-2" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()">
    <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
  </button>

  <a routerLink="/">
    <img title="Air Products" class="ap-main-logo" src="../../assets/images/ap-logo-white.png" />
  </a>
  <div style="margin-left: 100px;">
    <span>{{'ml_151220' | translate}}</span>
  </div>
  <div class="header-text">
    <span class="me-2"></span>
    <span flexChild></span>
    @if (account(); as acct) {
    <span class="mr8">{{'ml_143907' | translate}} {{(profileMe$ | async)?.fullName}}</span>
    } @else {
    <button color="primary" (click)="login()">Log In</button>
    }
  </div>
</mat-toolbar>

<mat-sidenav-container class="sidenav-container">
  <mat-sidenav disableClose #drawer class="sidenav" fixedInViewport
    [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'" [mode]="(isHandset$ | async) ? 'over' : 'side'"
    [opened]="(isHandset$ | async) === false">
    <ng-material-multilevel-menu [configuration]='menuConfig' [items]='appItems' (selectedItem)="selectedItem($event)"
      (menuIsReady)="menuIsReady($event)">
    </ng-material-multilevel-menu>

    <p style="position: fixed; left: 0; bottom: 0px; margin-bottom: 0px; z-index: -20; color: lightgrey;">
      v.20240911.1601</p>
  </mat-sidenav>
  <mat-sidenav-content>
    <div class="ms-3 me-3 mt-2 mb-2">

      @if(!router.url.includes(PageRoutePath.SUPERVISOR_DASHBOARD))
      {
      <router-outlet></router-outlet>
      }
      <div [hidden]="!router.url.includes(PageRoutePath.SUPERVISOR_DASHBOARD)">
        <app-iframe-report [reportSheetId]="reportSheetId" [reportName]="reportName"></app-iframe-report>
      </div>

    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
<iframe #loadiframe style="width: 1%; height: 1vh;" [src]="safeSrc">
</iframe>

}